import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import FJImageUploadValidator from '../view/steps/FJImageUploadValidator';
import FJActionHeadshotGenerator from '../../../../redux/action/FJActionHeadshotGenerator';

const FJImageUploadValidatorContainer = () => {
    const dispatch = useDispatch();

    // 从 Redux 获取状态
    const imageUploadStatus = useSelector(state => state.headshotGenerator.imageUploadStatus);
    const imageInfo = useSelector(state => state.headshotGenerator.imageInfo);

    // 处理图片上传
    const handleImageUpload = useCallback(
        file => {
            dispatch(FJActionHeadshotGenerator.setImageInfoAction(file));
        },
        [dispatch],
    );

    // 处理图片删除
    const handleImageDelete = useCallback(() => {
        dispatch(FJActionHeadshotGenerator.deleteImageInfoAction());
    }, [dispatch]);

    // 处理生成
    const handleGenerate = useCallback(() => {
        dispatch(FJActionHeadshotGenerator.onGenerationAction());
    }, [dispatch]);

    // 处理重新裁剪图片
    const handleReCropImage = useCallback(() => {
        dispatch(FJActionHeadshotGenerator.reCropImageAction());
    }, [dispatch]);

    return (
        <FJImageUploadValidator
            imageUploadStatus={imageUploadStatus}
            imageInfo={imageInfo}
            onImageUpload={handleImageUpload}
            onImageDelete={handleImageDelete}
            onGenerate={handleGenerate}
            onReCropImage={handleReCropImage}
        />
    );
};

export default FJImageUploadValidatorContainer;
